export default "__VITE_ASSET__8e92bbc0__"